import { Component, ChangeDetectionStrategy } from '@angular/core';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { RestartDeviceBaseDirective } from './restart-device.base.directive';

@Component({
  selector: 'ml-mdm-restart-device-dropdown-item',
  templateUrl: './restart-device-dropdown-item.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgbDropdownButtonItem, NgbDropdownItem],
})
export class RestartDeviceDropdownItemComponent extends RestartDeviceBaseDirective {}
